import { Component, Vue, Ref } from 'vue-property-decorator'
import MenuTable from './components/MenuTable'
import EditForm from './components/EditForm'
import {menuProps} from '@/utils/commonDef'
import {
  MasterlinkMenuCustomizationServiceProxy,
  DictServiceProxy,
  MasterlinkMenuTreeNode,
  MasterlinkMenuCustomization,
  TenantAppServiceProxy, TenantAppInfoVO
} from '@/service-proxies/app-v2/system.service-proxies'
const mmcsp = new MasterlinkMenuCustomizationServiceProxy()
const dsp = new DictServiceProxy()
const tasp = new TenantAppServiceProxy()

import './index.less'

@Component
export default class MenuMaintenance extends Vue { // 普通租户 - 菜单维护
  @Ref() editForm: EditForm

  additionalData: { kind: any[]; app: TenantAppInfoVO[] } = { kind: [], app: [] }
  loading = {
    select: false,
    search: false,
    menuTable: false,
    edit: false,
  }
  filter: { kind: number; app: string; keywords: string } = {
    kind: 3,
    app: void 0,
    keywords: '',
  }
  menuTableData: MasterlinkMenuTreeNode[] = []
  visible = {
    edit: false,
  }
  currentMenuId = ''
  currentRecord: {
    id: string | -1
    menuDescription: string | undefined
    menuSort: number | undefined
    menuSource: string | undefined
  } = null

  created() {
    this.loadAdditionalData().then(() => {
    this.loadTableData()
    })
  }

  async loadAdditionalData() {
    try {
      this.loading.select = true
      const [k, a] = await Promise.all([dsp.dictionary('menu_kind'), tasp.getTenantAppInfo()])
      this.additionalData = {
        kind: k.data,
        app: a,
      }
      const { kind } = this.additionalData
      if (kind.length > 0) {
        this.filter.kind = kind[0].dictKey
      }
    } catch (e) {
      console.log(e.message)
    } finally {
      this.loading.select = false
    }
  }

  async loadTableData() {
    try {
      this.loading.menuTable = true
      const {
        data: { menuTreeNodeList },
      } = await mmcsp.getMenus(this.filter.app, this.filter.kind, this.filter.keywords)
      this.menuTableData = menuTreeNodeList
    } catch (e) {
      console.log(e.message)
    } finally {
      this.loading.menuTable = false
    }
  }

  async handleSearch() {
    this.loading.search = true
    await this.loadTableData()
    this.loading.search = false
  }

  async clickRow(record: Partial<MasterlinkMenuTreeNode>) {
    this.currentMenuId = record.id
    const { data } = await mmcsp.getMenuCustomization(record.id)
    this.currentRecord = {
      id: data.id,
      menuDescription: this.$t(data.code) as string,
      menuSort: data.menuSort,
      menuSource: data.menuSource,
    }
    this.visible.edit = true
  }

  closeEditDrawer() {
    this.visible.edit = false
    this.currentRecord = null
  }

  handleEdit() {
    const { form } = this.editForm.dForm
    form.validateFields(async (err, values) => {
      console.log(values)
      // return
      if (!err) {
        try {
          this.visible.edit = false
          this.loading.menuTable = true
          // this.loading.edit = true
          await mmcsp.updateMenuCustomization({
            id: this.currentRecord.id === -1 ? '' : this.currentRecord.id,
            menuId: this.currentMenuId,
            sort: values.sort,
            source: values.source,
          } as MasterlinkMenuCustomization)
          this.$message.success(this.$t('page_resource_pool_success'))
          // this.loading.edit = false
          this.closeEditDrawer()
          await this.loadTableData()
        } catch (e) {
          this.loading.edit = false
          this.loading.menuTable = false
        }
      }
    })
  }

  changeKind(value){
    this.filter.kind = menuProps.find(item => item.hasOwnProperty('checkedDynamic') && item.checkedDynamic === value.target.checked).value
    // this.filter.kind = value.target.checked ? 2 : 3
  }

  render() {
    const header = () => (
      <div style="text-align: right">
        {/*<a-select
          v-model={this.filter.kind}
          style="width: 120px; margin-right: 16px"
          loading={this.loading.select}
          placeholder={this.$t('page_menu_category')}
          onChange={this.handleSearch}
        >
          {this.additionalData.kind.map(item => (
            <a-select-option value={item.dictKey}>{item.dictValue}</a-select-option>
          ))}
        </a-select>*/}
        {/*<a-checkbox onChange={this.changeKind}>
          {this.$t('page_menu_only_show_dynamic_menu')}
        </a-checkbox>*/}

        <a-select
          v-model={this.filter.app}
          style="width: 120px; margin-right: 16px"
          loading={this.loading.select}
          placeholder={this.$t('page_menu_app')}
          allowClear
          onChange={this.handleSearch}
        >
          {this.additionalData.app.map(item => (
            <a-select-option value={item.appId}>{this.$t(item.appCode)}</a-select-option>
          ))}
        </a-select>

        <a-input-search
          v-model={this.filter.keywords}
          placeholder={this.$t('keyword')}
          loading={this.loading.search}
          enterButton={this.$t('search')}
          style="width: 240px"
          onSearch={this.handleSearch}
          allowClear
        />
      </div>
    )
    const editDrawer = (
      <a-modal
        title={this.$t('edit')}
        placement="right"
        visible={this.visible.edit}
        get-container={false}
        wrap-style={{ position: 'absolute' }}
        width={600}
        onCancel={this.closeEditDrawer}
        mask={false}
      >
        <EditForm ref="editForm" key={Date.now()} record={this.currentRecord} />
        <a-button type="info" slot="footer" loading={this.loading.edit} onClick={this.closeEditDrawer}>
            {this.$t('cancel')}
          </a-button>
        <a-button type="primary" slot="footer" loading={this.loading.edit} onClick={this.handleEdit}>
            {this.$t('submit')}
          </a-button>
      </a-modal>
    )
    const body = () => (
      <div style="width: 100%; height: 100%; overflow-y: auto; overflow-x: hidden; position: relative">
        <MenuTable data={this.menuTableData} loading={this.loading.menuTable} onRowClick={this.clickRow} />
        {editDrawer}
      </div>
    )
    return (
      <collapse-view
        class="menu-maintenance"
        tabKeys={[1, 2]}
        tabKeysExt={[1, 2, 3]}
        scopedSlots={{ header, default: body }}
      />
    )
  }
}
